import { predefinedColors } from '@/pages/AdvancedEditor/components/panels/common/predefinedColors';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ColorPicker } from '../../../../../../components/ColorPicker';

const ColorContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    border-radius: 8px;

    & > span {
        height: fit-content !important;
    }

    > span > div {
        width: 24px !important;
        height: 24px !important;
        position: relative;
        border-radius: 4px !important;

        div {
            margin-top: 0px !important;
            width: 24px !important;
            height: 24px !important;
            border-radius: 4px;
        }
    }
`;

export const FontColorControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedElements;
    const element = elements[0] as ElementType & { fill: string };

    const handleChange = (fill: string) => {
        elements.forEach(element => element.set({ fill }));
    };

    return (
        <ColorContainer>
            <ColorPicker value={element.fill} onChange={handleChange} size="30px" predefinedColors={predefinedColors} />
        </ColorContainer>
    );
});
